module.exports = __webpack_public_path__ + "static/media/icon-community-person.3110340e.svg";